import { render, staticRenderFns } from "./large-text-section.vue?vue&type=template&id=3b7fd812&scoped=true&"
import script from "./large-text-section.vue?vue&type=script&lang=js&"
export * from "./large-text-section.vue?vue&type=script&lang=js&"
import style0 from "./large-text-section.vue?vue&type=style&index=0&id=3b7fd812&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7fd812",
  null
  
)

export default component.exports